import { memo } from 'react';
import classNames from 'classnames';
import range from 'lodash/range';

import FoldoutItem from '@/components/dropdown/components/foldout/FoldoutItem';
import { FoldoutOptionsProps } from '@/components/dropdown/types';
import Skeleton from '@/components/Skeleton';

const FoldoutOptions = ({
	additionalElements,
	handleItem,
	listVisible,
	nested,
	optionAdditionalSubValueKey,
	optionAvaKey,
	optionAvaPosition,
	optionCheckedKey,
	optionContinuationKey,
	optionDescriptionKey,
	optionFlagKey,
	optionFlagProperty,
	optionForDisabled,
	optionIconKey,
	optionImageKey,
	optionLabelKey,
	optionAdditionalLabelKey,
	optionSectionBodyKey,
	optionSectionKey,
	optionSubValueKey,
	optionTitleKey,
	optionTypeKey,
	optionValueKey,
	optionButtonType,
	optionClassName,
	options = [],
	selectValue,
	skeletonOptions,
	type,
}: FoldoutOptionsProps) => {
	const sectionKey = optionSectionKey || 'section';
	const bodyKey = optionSectionBodyKey || 'body';

	return !options.length ? (
		!!skeletonOptions && (
			<>
				{range(skeletonOptions).map((_n, i) => (
					<Skeleton key={i} className="skeleton-option" />
				))}
			</>
		)
	) : (
		<>
			{options.map((item: any, index: number) => {
				return (
					<div
						key={index}
						className={classNames('section', { nested })}
						data-testid="section"
					>
						{nested ? (
							<>
								{item[sectionKey] && (
									<h5 className="section-title">{item[sectionKey]}</h5>
								)}
								{item[bodyKey].map((row: any, rowIndex: number) => {
									return (
										<FoldoutItem
											key={rowIndex}
											handleItem={handleItem}
											item={row}
											listVisible={listVisible}
											optionAdditionalSubValueKey={
												optionAdditionalSubValueKey
											}
											optionAvaKey={optionAvaKey}
											optionAvaPosition={optionAvaPosition}
											optionCheckedKey={optionCheckedKey}
											optionContinuationKey={optionContinuationKey}
											optionDescriptionKey={optionDescriptionKey}
											optionFlagKey={optionFlagKey}
											optionFlagProperty={optionFlagProperty}
											optionForDisabled={optionForDisabled}
											optionIconKey={optionIconKey}
											optionImageKey={optionImageKey}
											optionLabelKey={optionLabelKey}
											optionAdditionalLabelKey={optionAdditionalLabelKey}
											optionSubValueKey={optionSubValueKey}
											optionTitleKey={optionTitleKey}
											optionTypeKey={optionTypeKey}
											optionValueKey={optionValueKey}
											optionButtonType={optionButtonType}
											optionClassName={optionClassName}
											selectValue={selectValue}
											type={type}
										/>
									);
								})}
							</>
						) : (
							<FoldoutItem
								handleItem={handleItem}
								item={item}
								listVisible={listVisible}
								optionAvaKey={optionAvaKey}
								optionAvaPosition={optionAvaPosition}
								optionCheckedKey={optionCheckedKey}
								optionContinuationKey={optionContinuationKey}
								optionDescriptionKey={optionDescriptionKey}
								optionFlagKey={optionFlagKey}
								optionFlagProperty={optionFlagProperty}
								optionForDisabled={optionForDisabled}
								optionIconKey={optionIconKey}
								optionImageKey={optionImageKey}
								optionLabelKey={optionLabelKey}
								optionAdditionalLabelKey={optionAdditionalLabelKey}
								optionTitleKey={optionTitleKey}
								optionTypeKey={optionTypeKey}
								optionValueKey={optionValueKey}
								optionButtonType={optionButtonType}
								optionClassName={optionClassName}
								selectValue={selectValue}
								type={type}
							/>
						)}
					</div>
				);
			})}
			{additionalElements}
		</>
	);
};

export default memo(FoldoutOptions);
